import SurveyorStats from '../SurveyorStats';
import ApplicationScheduleFields from '../Schedule/ApplicationScheduleFields';
import MultiDateCalendar from '../MultiDateCalendar';
import { broadcastSlots, broadcastSlotErrors } from './eventCreationSchedule';
import { Modal, ModalDialog, ModalOverflow, ModalClose, Typography, Stack, Button, Sheet } from '@mui/joy';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { LayoutContext } from '../../context';
import { APIDispatchDetail, APIDispatchAccept, APIDispatchStart, APIDispatchCancel } from '../../api';
import { dispatchLabels, responseLabels, responseArrival, formatDispatchInstant, dispatchSchedule } from '../../dispatchUi';

export default function ModalDispatchResponses() {
    const { modalDispatchResponses, setModalDispatchResponses, tokenEmployee } = useContext(LayoutContext);
    const id = modalDispatchResponses?.dispatchId;
    const open = !!modalDispatchResponses?.open;
    const [dispatch, setDispatch] = useState(null);
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const [restartSlots, setRestartSlots] = useState([]);
    const flight = useRef(false);
    const sequence = useRef(0);
    const load = useCallback(async () => {
        const seq = ++sequence.current;
        const result = await APIDispatchDetail(id, tokenEmployee);
        if (seq !== sequence.current) return;
        if (result?.id) setDispatch(result);
        else setError(result?.message || 'Не удалось получить отклики');
    }, [id, tokenEmployee]);
    useEffect(() => {
        setDispatch(null); setError(''); setRestartSlots([]);
        if (!open || !id) return undefined;
        load(); const timer = setInterval(load, 10000);
        return () => { clearInterval(timer); sequence.current += 1; };
    }, [open, id, load]);
    useEffect(() => { if (dispatch) setRestartSlots(dispatchSchedule(dispatch)); }, [dispatch?.id, dispatch?.broadcast_started_at]);
    const perform = async operation => {
        if (flight.current) return;
        flight.current = true; setBusy(true); setError('');
        try {
            const result = await operation();
            if (!result?.id) setError(result?.message || 'Операция не выполнена');
            else setDispatch(result);
            await load();
        } catch (_) { setError('Ошибка связи. Обновите карточку.'); }
        finally { flight.current = false; setBusy(false); }
    };
    if (!open) return null;
    return <Modal open onClose={() => { if (!busy) setModalDispatchResponses({ open: false }); }} sx={{ zIndex: 10103 }}>
        <ModalOverflow><ModalDialog sx={{ width: 'min(760px, 95vw)' }}>
            <ModalClose disabled={busy} />
            <Typography level="h4">Отклики на заявку</Typography>
            {error && <Typography color="danger" role="alert">{error}</Typography>}
            <Button variant="plain" onClick={load} disabled={busy}>Обновить</Button>
            {dispatch && <>
                <Typography>{dispatchLabels[dispatch.status] || dispatch.status}</Typography>
                <Typography level="body-sm">Время объекта: {dispatch.event_timezone}. Автовыбор первого актуального отклика через 15 минут; затем 15 минут на подтверждение.</Typography>
                {dispatch.timeout_at && <Typography level="body-sm">Следующая проверка: {formatDispatchInstant(dispatch.timeout_at, dispatch.event_timezone)}</Typography>}
                {!dispatch.responses?.length && <Typography>Актуальных откликов пока нет.</Typography>}
                <Stack spacing={1}>
                    {(dispatch.responses || []).map(r => <Sheet key={r.id} variant="outlined" sx={{ p: 1.5, borderRadius: 'md' }}>
                        <Typography level="title-md">{r.employee?.last_name} {r.employee?.name}</Typography><SurveyorStats employee={r.employee}/>
                        <Typography>{responseLabels[r.status] || r.status}</Typography>
                        <Typography>Прибытие: {responseArrival(r)}</Typography>
                        <Typography level="body-sm">Отклик: {formatDispatchInstant(r.date_create, dispatch.event_timezone)}</Typography>
                        {r.employee_comment && <Typography>{r.employee_comment}</Typography>}
                        {r.status === 'pending' && r.arrival_time && ['broadcasting', 'reassign_needed'].includes(dispatch.status) &&
                            <Button disabled={busy} onClick={() => perform(() => APIDispatchAccept(dispatch.id, r.id, tokenEmployee))}>Выбрать</Button>}
                    </Sheet>)}
                </Stack>
                {dispatch.status !== 'assigned' && <Sheet variant="soft" sx={{ p: 1.5 }}>
                    <Typography level="title-sm">Перезапуск распределения</Typography>
                    <Typography level="body-sm">Текущие отклики будут отозваны. Обмерщики получат новое приглашение.</Typography>
                    <Typography level="body-xs">Часовой пояс объекта: {dispatch.event_timezone}. У каждого дня собственное время прибытия.</Typography>
                    <ApplicationScheduleFields showTimezone={false} form={{desired_time: 'pick_dates', desired_slots: restartSlots}}
                        options={[]} onChange={value => { if (value.desired_slots) setRestartSlots(value.desired_slots); }}
                        renderCalendar={props => <MultiDateCalendar {...props}/>}/>
                    <Button disabled={busy} onClick={() => {
                        const dates = restartSlots.map(slot => slot.date);
                        const issues = broadcastSlotErrors(dates, '', '', restartSlots);
                        if (Object.keys(issues).length) { setError(Object.values(issues).join(' ')); return; }
                        if (!window.confirm('Отозвать текущие отклики и запустить новую рассылку?')) return;
                        perform(() => APIDispatchStart(dispatch.event, 'city', {
                            restart: !!dispatch.broadcast_started_at,
                            ...(dispatch.broadcast_started_at ? { broadcast_started_at: dispatch.broadcast_started_at } : {}),
                            ...broadcastSlots(dates, '', '', restartSlots),
                        }, tokenEmployee));
                    }}>Перезапустить</Button>
                    {dispatch.status !== 'unassigned' && <Button color="danger" variant="plain" disabled={busy} onClick={() => {
                        if (!window.confirm('Остановить рассылку и отозвать текущие отклики?')) return;
                        perform(() => APIDispatchCancel(dispatch.id, dispatch.broadcast_started_at, tokenEmployee));
                    }}>Остановить рассылку</Button>}
                </Sheet>}
            </>}
        </ModalDialog></ModalOverflow>
    </Modal>;
}
